import React, { useEffect, createElement } from 'react';
import { CheckCircle, Users } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaAiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'Book-Call-PV');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const wistiaEmbedScript = document.createElement('script');
    wistiaEmbedScript.src = 'https://fast.wistia.com/embed/1n1c7tnsqb.js';
    wistiaEmbedScript.async = true;
    wistiaEmbedScript.type = 'module';
    document.head.appendChild(wistiaEmbedScript);
    const wistiaStyle = document.createElement('style');
    wistiaStyle.textContent = `wistia-player[media-id='1n1c7tnsqb']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1n1c7tnsqb/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(wistiaStyle);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(wistiaEmbedScript);
      document.head.removeChild(wistiaStyle);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-1866">
      {/* Hero Section */}
      <section className="pt-6 md:pt-20 pb-12 md:pb-16 bg-gradient-to-b from-gray-900 to-black" data-id="element-1867">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-1868">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 leading-tight text-center tracking-tight" data-id="element-1869">
            Agenda Tu Llamada de Claridad
          </h1>

          {/* Wistia Video */}
          <div className="mb-8 rounded-2xl overflow-hidden border-2 border-cyan-500 shadow-2xl" data-id="element-1870">
            <wistia-player media-id="1n1c7tnsqb" aspect="1.7777777777777777" data-id="element-1871"></wistia-player>
          </div>

          {/* Qualification Message */}
          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-2xl p-6 md:p-8 border-2 border-cyan-500 mb-8 shadow-2xl" data-id="element-1872">
            <div className="flex items-start gap-4 mb-4" data-id="element-1873">
              <CheckCircle className="w-6 h-6 md:w-7 md:h-7 text-cyan-400 flex-shrink-0 mt-1" data-id="element-1874" />
              <div data-id="element-1875">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-1876">
                  Proceso de Calificación
                </h2>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-1877">
                  Para poder hablar con nuestro equipo, primero debemos
                  verificar si eres un buen candidato para esta oportunidad. Por
                  favor, completa el formulario a continuación para agendar tu
                  llamada de claridad.
                </p>
              </div>
            </div>
          </div>

          {/* Benefits List */}
          <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700 mb-10" data-id="element-1878">
            <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-1879">
              <Users className="w-6 h-6 text-cyan-400" data-id="element-1880" />
              En esta llamada descubrirás:
            </h3>
            <div className="space-y-3" data-id="element-1881">
              {['Si 48/hrs AI Cash Machine es adecuado para tu situación actual', 'Cómo implementar el sistema paso a paso en tu negocio', 'Estrategias personalizadas para tu nicho específico', 'Respuestas a todas tus preguntas sobre el programa'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1882">
                  <CheckCircle className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-1883" />
                  <span className="text-gray-200 text-sm md:text-base" data-id="element-1884">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-12 md:py-16 bg-gradient-to-b from-black to-gray-900" data-id="element-1885">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-1886">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700" data-id="element-1887">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 text-center" data-id="element-1888">
              ¿Qué Esperar de la Llamada?
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-1889">
              <div className="space-y-3" data-id="element-1890">
                <div className="flex items-start gap-3" data-id="element-1891">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-1892">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-1893" />
                  </div>
                  <div data-id="element-1894">
                    <p className="font-semibold text-white text-sm" data-id="element-1895">
                      Duración: 30-45 minutos
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-1896">
                      Tiempo suficiente para conocerte
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-1897">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-1898">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-1899" />
                  </div>
                  <div data-id="element-1900">
                    <p className="font-semibold text-white text-sm" data-id="element-1901">
                      Formato: Video llamada
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-1902">
                      Conexión personal y directa
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-1903">
                <div className="flex items-start gap-3" data-id="element-1904">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-1905">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-1906" />
                  </div>
                  <div data-id="element-1907">
                    <p className="font-semibold text-white text-sm" data-id="element-1908">
                      Sin presión de venta
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-1909">
                      Solo asesoría honesta
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-1910">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-1911">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-1912" />
                  </div>
                  <div data-id="element-1913">
                    <p className="font-semibold text-white text-sm" data-id="element-1914">
                      Plan personalizado
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-1915">
                      Adaptado a tu situación
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-1916" />
      <WhatsAppButton data-id="element-1917" />
    </div>;
}